import Link from 'next/link'
import React from 'react'
import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn'
import { useUser } from 'src/common/hooks/useUser'
import { RegisterForm } from './RegisterForm'

export const AccountSection = () => {
    const isLoggedIn = useIsLoggedIn()
    const user = useUser()

    return (
        <div className="w-full shadow-md rounded-md p-8 border border-gray-200 bg-white mb-4">
            <div className="flex items-center justify-between flex-wrap md:flex-nowrap">
                <div className="flex items-center">
                    <div className="w-10 h-10 border-2 border-yf-green rounded-full flex items-center justify-center font-medium mr-5 text-lg flex-shrink-0">
                        1
                    </div>
                    <p className="uppercase text-yf-green font-medium text-xl md:text-2xl flex w-full">
                        {isLoggedIn ? 'Account' : 'Create an Account'}
                    </p>
                </div>
                <div>
                    {!isLoggedIn && (
                        <Link href="/login">
                            <a className="underline text-yf-purple flex mt-4 md:mt-0">
                                {' '}
                                Existing user? Sign in.
                            </a>
                        </Link>
                    )}
                </div>
            </div>

            <div className="h-px bg-gray-300 my-4"></div>

            {isLoggedIn ? (
                <div>{user.email}</div>
            ) : (
                <div>
                    <RegisterForm />
                </div>
            )}
        </div>
    )
}
